import {
  Container,
  MenuItem,
  TextField,
  InputAdornment,
  FormControl,
  Select,
  InputLabel,
} from "@mui/material";
import NavigationPage from "../../../ui/templates/NavigationPage";
import ExtraCourseList from "../components/ExtraCourses";
import { useState } from "react";
import { Search } from "@mui/icons-material";
import { useLocation, useSearchParams } from "react-router-dom";

const ExtraCoursesPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const ids = searchParams.get("ids")?.split(",") || [];
  const [filters, setFilters] = useState("Todos");
  const [search, setSearch] = useState();

  const onChangeFilter = (e) => {
    setFilters((prev) => e.target.value);
  };
  const onChangeSearch = (e) => {
    setSearch((prev) => e.target.value);
  };
  return (
    <NavigationPage
      rootRoute={{ label: "Cursos extras", route: "/extras" + location.search }}
      actions={
        <span className="flex flex-row gap-2">
          <TextField
            label="Procurar"
            value={search}
            onChange={onChangeSearch}
            variant="standard"
            placeholder="Procurar nome do curso"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />

          <FormControl>
            <InputLabel variant="standard" className="text-sm">
              Filtrar cursos
            </InputLabel>
            <Select
              label={<>"Filtrar por"</>}
              value={filters}
              onChange={onChangeFilter}
              variant="standard"
            >
              <MenuItem value="Todos">Todos cursos</MenuItem>
              <MenuItem value="Em andamento">Em andamento</MenuItem>
              <MenuItem value="Concluídos">Concluídos</MenuItem>
              <MenuItem value="Expirados">Expirados</MenuItem>
              <MenuItem value="Sem matrícula">Sem matrícula</MenuItem>
            </Select>
          </FormControl>
        </span>
      }
    >
      <Container maxWidth={false} sx={{ position: "relative", height: "100%" }}>
        <div className="relative h-full w-full">
          <ExtraCourseList filters={{ ids, search, status: filters }} />
        </div>
      </Container>
    </NavigationPage>
  );
};

export default ExtraCoursesPage;
